import { useCallback, useMemo, useState } from "react";

/**
 * v2 settings WRITE icin kirli alan takibi.
 * Her change item: { group, key, value, potIndex?, subgroup?, cupId?, mode? }
 * (server'in `v2-device-setting.controller.js`'deki validateChangesPayload'i ile uyumlu)
 *
 * Ayni (group, key, potIndex, subgroup, cupId, mode) bilesimi icin
 * yeni change replace eder (son value tutulur).
 */
export default function useDirtyChanges() {
  const [changes, setChanges] = useState([]);

  const sameKey = (a, b) =>
    a.group === b.group &&
    a.key === b.key &&
    a.potIndex === b.potIndex &&
    a.subgroup === b.subgroup &&
    a.cupId === b.cupId &&
    a.mode === b.mode;

  const upsert = useCallback((change) => {
    setChanges((prev) => {
      const filtered = prev.filter((c) => !sameKey(c, change));
      return [...filtered, change];
    });
  }, []);

  const remove = useCallback((change) => {
    setChanges((prev) => prev.filter((c) => !sameKey(c, change)));
  }, []);

  const clear = useCallback(() => setChanges([]), []);

  const count = changes.length;
  const isDirty = useMemo(() => count > 0, [count]);

  return { changes, upsert, remove, clear, count, isDirty };
}
